"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,2 C17.5227273,2 22,6.47727273 22,12 C22,17.5227273 17.5227273,22 12,22 C6.47727273,22 2,17.5227273 2,12 C2,6.47727273 6.47727273,2 12,2 Z M14.8284271,7.75735931 L12.0003593,10.5863593 L9.17157288,7.75735931 L7.75735931,9.17157288 L10.5863593,12.0003593 L7.75735931,14.8284271 L9.17157288,16.2426407 L12.0003593,13.4143593 L14.8284271,16.2426407 L16.2426407,14.8284271 L13.4143593,12.0003593 L16.2426407,9.17157288 L14.8284271,7.75735931 Z"
  });
}.bind(void 0));

exports.default = _default;